import axios from '@axios'
import moment from 'moment'

const basePath = '/api/sales/delivery/auto-delivery-monitor'

export const periodPresets = {
  LAST_HOUR: 'lastHour',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last7Days',
  CUSTOM: 'custom',
}

// Período enviado à API (docs/painel-monitoramento-entrega-automatica.md §4.1). Datas no fuso
// do operador, convertidas para ISO.
export const resolvePeriod = (preset, rangeDate, now = moment()) => {
  switch (preset) {
    case periodPresets.LAST_HOUR:
      return { from: now.clone().subtract(1, 'hour'), to: now.clone() }
    case periodPresets.YESTERDAY:
      return {
        from: now.clone().subtract(1, 'day').startOf('day'),
        to: now.clone().startOf('day'),
      }
    case periodPresets.LAST_7_DAYS:
      return { from: now.clone().subtract(7, 'days'), to: now.clone() }
    case periodPresets.CUSTOM:
      return {
        from: moment(rangeDate?.startDate).startOf('day'),
        to: moment(rangeDate?.endDate).endOf('day'),
      }
    default:
      return { from: now.clone().startOf('day'), to: now.clone() }
  }
}

const getInitialFilters = () => ({
  storeIds: [],
  periodPreset: periodPresets.TODAY,
  rangeDate: {
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  },
})

const getInitialState = () => ({
  filters: getInitialFilters(),
  overview: null,
  health: null,
  fetching: false,
  lastUpdatedAt: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    sales: state => state.overview?.sales || [],
    stores: state => state.overview?.stores || [],
    summary: state => state.overview?.summary || null,
    alerts: state => state.health?.alerts || [],
  },

  mutations: {
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters }
    },
    RESET_FILTERS(state) {
      state.filters = getInitialFilters()
    },
    SET_FETCHING(state, fetching) {
      state.fetching = fetching
    },
    SET_DATA(state, { overview, health }) {
      state.overview = overview
      state.health = health
      state.lastUpdatedAt = new Date()
    },
  },

  actions: {
    // Visão do período e saúde atual sempre juntas, para o painel ficar coerente.
    async fetchMonitor({ commit, state }) {
      const { from, to } = resolvePeriod(state.filters.periodPreset, state.filters.rangeDate)
      // Sem lojas selecionadas o parâmetro não vai: o querystring serializa undefined como
      // "storeIds=", que a API interpretaria como um valor vazio.
      const storeParams = state.filters.storeIds?.length ? { storeIds: state.filters.storeIds } : {}
      commit('SET_FETCHING', true)
      try {
        const [overview, health] = await Promise.all([
          axios.get(`${basePath}/overview`, {
            params: { ...storeParams, from: from.toISOString(), to: to.toISOString() },
          }),
          axios.get(`${basePath}/health`, { params: storeParams }),
        ])
        commit('SET_DATA', { overview: overview.data, health: health.data })
      } finally {
        commit('SET_FETCHING', false)
      }
    },

    async fetchSaleDetail(_, saleId) {
      const { data } = await axios.get(`${basePath}/sales/${saleId}`)
      return data
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('RESET_FILTERS')
    },
  },
}
